import React from 'react';
import GenericPage from './GenericPage';
import ProgressBar from '../components/ProgressBar';

const LabProgressPage = () => {
    return (
        <>
        {<GenericPage active='Pruebas de Laboratorio'>
            <ProgressBar />
        </GenericPage>}
        </>
    );
}

export default LabProgressPage;
